"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupFieldsBySection = groupFieldsBySection;
/**
 * Alanları bölüme göre gruplar. Tanımlı bölümler `labels`'taki `order`'a göre sıralanır;
 * bölümü olmayan alanlar sona "Genel" başlıklı tek gruba toplanır. Alan sırası korunur.
 */
function groupFieldsBySection(fields, labels) {
    const bySection = new Map();
    const general = [];
    for (const [key, field] of Object.entries(fields)) {
        const sid = field.section;
        if (sid && labels?.[sid]) {
            const list = bySection.get(sid) ?? [];
            list.push({ key, field });
            bySection.set(sid, list);
        }
        else {
            general.push({ key, field });
        }
    }
    const groups = [...bySection.entries()]
        .sort((a, b) => (labels?.[a[0]].order ?? 0) - (labels?.[b[0]].order ?? 0))
        .map(([sectionId, list]) => ({ sectionId, label: labels?.[sectionId].label ?? sectionId, fields: list }));
    if (general.length > 0) {
        groups.push({ sectionId: null, label: "Genel", fields: general });
    }
    return groups;
}
//# sourceMappingURL=section.js.map